import { useQuery } from '@tanstack/react-query'

import { useApi } from 'contexts/api-context'

import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import type { Match, UseQueryOmissions } from 'types'

type GetMatchesProps = {
  customerId: string
  startDate: string
  endDate: string
  includeCustomerIds?: boolean
}
const buildGetMatchesUrl = (customerId: string, startDate: string, endDate: string, includeCustomerIds: boolean) => {
  const params = {
    startdate: startDate,
    enddate: endDate,
    includeCustomerIds: includeCustomerIds.toString(),
  }
  let url = `/compconnector/cust/${customerId}/matches`
  if (params) url += `?${new URLSearchParams(params)}`

  return url
}

export const useGetCustomerMatches = (
  props: GetMatchesProps & { alt?: string },
  queryProps?: Omit<UseQueryOptions<Match[], Error>, UseQueryOmissions>
): UseQueryResult<Match[], Error> => {
  const api = useApi()
  const { customerId, startDate, endDate, includeCustomerIds = false } = props
  const url = buildGetMatchesUrl(customerId, startDate, endDate, includeCustomerIds)
  return useQuery<Match[], Error>({
    queryKey: ['matches', props],
    queryFn: () => api.get(url),
    staleTime: Infinity,
    enabled: !!customerId,
    ...queryProps,
  })
}

export const useGetMatch = (
  customerId?: string,
  matchId?: string,
  queryProps?: Omit<UseQueryOptions<Match, Error>, UseQueryOmissions>
): UseQueryResult<Match, Error> => {
  const api = useApi()
  return useQuery<Match, Error>({
    queryKey: ['matches', { customerId, matchId }],
    queryFn: () => api.get(`/compconnector/cust/${customerId}/matches/${matchId}`),
    staleTime: Infinity,
    enabled: !!customerId && !!matchId,
    ...queryProps,
  })
}
